import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetParameterByKeyCommand extends IRequestCommand<
  IReadParametersCommandResponse,
  ErrorDetails,
  IReadParametersCommandRequest
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

  public setParameter(carrierUserId: number, parameter: string): void {
    this.urlSections.push('carriers');
    this.urlSections.push(`${carrierUserId}`);
    this.urlSections.push('parameter');
    this.paramsSections.push(`key=${parameter}`)
    this.composeUrl();
  }
}

export interface IReadParametersCommandRequest extends ICommandParameters {}

export interface IReadParametersCommandResponse extends ICommandResponse {}
